// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sidebar_wrapper__lengx","drawer":"Sidebar_drawer__FMtn_","header":"Sidebar_header__XHCvL"};